import {createHash} from 'crypto';

export const getHash = (value) => {
  value = value.trim().toLowerCase();
  return createHash('sha256').update(value).digest('hex');
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/getHash.js